import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { StoreProvider, ShareableLink, Label } from '../../components';

function humanizeHour(hour) {
  return moment().hour(hour).startOf('hour').format('h:mma');
}

function humanizePhone(phoneNumber) {
  const areaCode = phoneNumber.slice(0, 3);
  const prefix = phoneNumber.slice(3, 6);
  const suffix = phoneNumber.slice(6);

  return `(${areaCode}) ${prefix}-${suffix}`;
}

function splitLines(text) {
  return (
    <div>
      {text.split('\n').map((line, i) => (
        <div key={i}>{line}</div>
      ))}
    </div>
  );
}

export class MallShowView extends Component {
  render() {
    const { mall } = this.props;
    return (
      <div className="mall-info">
        <div className="header">
          <h2>Mall Info</h2>
          <div className="actions">
            <Link to="/mall-info/edit" className="button">
              Edit Mall Info
            </Link>
          </div>
        </div>
        <dl>
          <dt>Name</dt>
          <dd className="name">{mall.name}</dd>

          <dt>Location</dt>
          <dd className="location">{splitLines(mall.address)}</dd>

          <dt>Phone Number</dt>
          <dd className="phone-number">{humanizePhone(mall.phoneNumber)}</dd>

          <dt>Email Address</dt>
          <dd className="email">{mall.email}</dd>

          <dt>Monday Hours</dt>
          <dd className="monday-hours">{`${humanizeHour(
            mall.mondayOpening
          )} - ${humanizeHour(mall.mondayClosing)}`}</dd>

          <dt>Tuesday Hours</dt>
          <dd className="tuesday-hours">{`${humanizeHour(
            mall.tuesdayOpening
          )} - ${humanizeHour(mall.tuesdayClosing)}`}</dd>

          <dt>Wednesday Hours</dt>
          <dd className="wednesday-hours">{`${humanizeHour(
            mall.wednesdayOpening
          )} - ${humanizeHour(mall.wednesdayClosing)}`}</dd>
          
          <dt>Thursday Hours</dt>
          <dd className="hursday-hours">{`${humanizeHour(
            mall.thursdayOpening
          )} - ${humanizeHour(mall.thursdayClosing)}`}</dd>
          
          <dt>Friday Hours</dt>
          <dd className="friday-hours">{`${humanizeHour(
            mall.fridayOpening
          )} - ${humanizeHour(mall.fridayClosing)}`}</dd>
          
          <dt>Saturday Hours</dt>
          <dd className="saturday-hours">{`${humanizeHour(
            mall.saturdayOpening
          )} - ${humanizeHour(mall.saturdayClosing)}`}</dd>
          
          <dt>Sunday Hours</dt>
          <dd className="sunday-hours">{`${humanizeHour(
            mall.sundayOpening
          )} - ${humanizeHour(mall.sundayClosing)}`}</dd>
          
        </dl>
        <div className="mall-links">
          <ShareableLink
            name="shareableHomeUrl"
            title="Shareable Home Link"
            url={mall.shareableHomeUrl}
          />
          <ShareableLink name="homeUrl" title="Home Link" url={mall.homeUrl} />
          <ShareableLink
            name="shareableFlashSaleOffersUrl"
            title="Shareable Flash Sale Offers Link"
            url={mall.shareableFlashSaleOffersUrl}
          />
          <ShareableLink
            name="flashSaleOffersUrl"
            title="Flash Sale Offers Link"
            url={mall.flashSaleOffersUrl}
          />
          <ShareableLink
            name="pdfMapUrl"
            title="Link for PDF"
            url={mall.pdfMapUrl}
          />
        </div>
        <div className="form-group-row">
          <div className="input mall-image-upload">
            <div className="image-upload-header">
              <Label attr="smallMap" text="Small Map" />
            </div>
            <div className="mall-image-upload-dropzone">
              <div className="image-preview-wrapper">
                <div
                  className="image-preview"
                  style={{ backgroundImage: `url("${mall.smallMapUrl}")` }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group-row">
          <div className="input mall-image-upload">
            <div className="image-upload-header">
              <Label attr="largeMap" text="Large Map" />
            </div>
            <div className="mall-image-upload-dropzone">
              <div className="image-preview-wrapper">
                <div
                  className="image-preview"
                  style={{ backgroundImage: `url("${mall.largeMapUrl}")` }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Container = createFragmentContainer(MallShowView, {
  mall: graphql`
    fragment MallShow_mall on Mall {
      name
      phoneNumber
      email
      pdfMapUrl
      address
      shareableHomeUrl
      shareableFlashSaleOffersUrl
      smallMapUrl
      largeMapUrl
      homeUrl
      flashSaleOffersUrl
      mondayOpening
      mondayClosing
      tuesdayOpening
      tuesdayClosing
      wednesdayOpening
      wednesdayClosing
      thursdayOpening
      thursdayClosing
      fridayOpening
      fridayClosing
      saturdayOpening
      saturdayClosing
      sundayOpening
      sundayClosing
    }
  `,
});

export default class MallShow extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query MallShowQuery {
            mall {
              ...MallShow_mall
            }
          }
        `}
      />
    );
  }
}
